var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState, useEffect, useMemo } from "react";
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import NewEl from './newel';
import ChooseEl from './chooseel';
import BottomTextEditor from './texteditormobile';
import useCommonProps from "../../../../hooks/useCommonProps";
import { WIDE_PRESENTATION_RATIO } from '../../../../constants/media';
import { getCurrentEditLongread } from "../../../../reducers/setEditLongRead";
import { useLockBodyScroll } from "@brg/ui";
import { useGeneralProps } from '../../../../hooks/useGeneralProps';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin-top: 40px;\n  background: #fefefe;\n  border: 4px solid #f1db63;\n  box-sizing: border-box;\n  box-shadow: none;\n  color: #151514;\n  padding: 40px 48px;\n"], ["\n  position: relative;\n  margin-top: 40px;\n  background: #fefefe;\n  border: 4px solid #f1db63;\n  box-sizing: border-box;\n  box-shadow: none;\n  color: #151514;\n  padding: 40px 48px;\n"])));
var ChooseWrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media (max-width: 940px) {\n    display: none;\n  }\n"], ["\n  @media (max-width: 940px) {\n    display: none;\n  }\n"])));
function Editor(props) {
    var _a = useState(''), editor = _a[0], setEditor = _a[1];
    var _b = useState(null), files = _b[0], setFiles = _b[1];
    var _c = useState(''), dropZone = _c[0], setDropZone = _c[1];
    var lgid = props.lgid, doiserStates = props.doiserStates, colorStyle = props.colorStyle, editLongRead = props.editLongRead, onNewPost = props.onNewPost, specialTools = props.specialTools, thematic = props.thematic, appName = props.appName, hasSpecialSourcesBlocks = props.hasSpecialSourcesBlocks, bookId = props.bookId, firstAsCover = props.firstAsCover, isPresentation = props.isPresentation, onPresentationHeaderChange = props.onPresentationHeaderChange, canAddSpBLock = props.canAddSpBLock, typeConnection = props.typeConnection, editorComponent = props.editorComponent, onLongreadIsReady = props.onLongreadIsReady, commentsAllowed = props.commentsAllowed, allowedActions = props.allowedActions, importantStyle = props.importantStyle, theme = props.theme, isFeed = props.isFeed, blockLength = props.blockLength, isGalleryBp = props.isGalleryBp;
    var setStoryEditor = function () {
        setEditor('story');
    };
    var setChooserEditor = function () {
        setEditor('');
    };
    var setLoadedAction = function (files) {
        setFiles(files);
    };
    var setLoadedDropZone = function (zone) {
        setDropZone(zone);
    };
    useEffect(function () {
        return function () {
            setEditor('');
        };
    }, []);
    var _d = useCommonProps(), fixedRatio = _d.fixedRatio, viewType = _d.viewType, teamContexts = _d.teamContexts, teamExtraFilter = _d.teamExtraFilter, onOpenSetProjectsModal = _d.onOpenSetProjectsModal, sign = _d.sign, isLMS = _d.isLMS, isLMSMain = _d.isLMSMain, projectId = _d.projectId, teamId = _d.teamId, toggleMobileEditor = _d.toggleMobileEditor;
    var generalProps = useGeneralProps();
    var maxProjects = useMemo(function () { return (fixedRatio === WIDE_PRESENTATION_RATIO || ['fluid', 'fixed-ratio-large', 'free-type'].includes(viewType)) ? 3 : 2; }, [fixedRatio, viewType]);
    // if (editor === 'story') {
    return (React.createElement(NewEl, { theme: theme, blockLength: blockLength, hasSpecialSourcesBlocks: hasSpecialSourcesBlocks, canAddSpBLock: canAddSpBLock, lgid: lgid, typeConnection: typeConnection, bookId: bookId, ev: files, dropZone: dropZone, allowedActions: allowedActions, doiserStates: doiserStates, commentsAllowed: commentsAllowed, colorStyle: colorStyle, onNewPost: onNewPost, specialTools: specialTools, num: editLongRead.num, setLoadedAction: setLoadedAction, setLoadedDropZone: setLoadedDropZone, setChooserEditor: setChooserEditor, thematic: thematic, toggleMobileEditor: toggleMobileEditor, appName: appName, firstAsCover: firstAsCover, isPresentation: isPresentation, onPresentationHeaderChange: onPresentationHeaderChange, editorComponent: editorComponent, onLongreadIsReady: onLongreadIsReady, maxProjects: maxProjects, viewType: viewType, teamContexts: teamContexts, teamExtraFilter: teamExtraFilter, onOpenSetProjectsModal: onOpenSetProjectsModal, isLMS: isLMS, isLMSMain: isLMSMain, sign: sign, generalProps: generalProps, teamId: teamId, isFeed: isFeed, projectId: projectId, isGalleryBp: isGalleryBp, importantStyle: importantStyle }));
    // }
    // return (
    //   <ChooseWrap>
    //     <ChooseEl
    //       lgid={lgid}
    //       setEditor={setStoryEditor}
    //       setLoadedAction={setLoadedAction}
    //       setLoadedDropZone={setLoadedDropZone}
    //       colorStyle={colorStyle}
    //     />
    //   </ChooseWrap>
    // )
}
var mapStateToProps = function (store, _a) {
    var currentId = _a.lgid;
    var newEditLongread = getCurrentEditLongread(store, currentId);
    return {
        // countryInnerPageData: store.countryInnerPage.data,
        editLongRead: newEditLongread
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
    // setCreator: (creatorOptions) => dispatch(setCreator(creatorOptions))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Editor);
var templateObject_1, templateObject_2;
//# sourceMappingURL=editor.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState, useEffect, useMemo } from "react";
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import NewEl from './newel';
import ChooseEl from './chooseel';
import BottomTextEditor from './texteditormobile';
import useCommonProps from "../../../../hooks/useCommonProps";
import { WIDE_PRESENTATION_RATIO } from '../../../../constants/media';
import { getCurrentEditLongread } from "../../../../reducers/setEditLongRead";
import { useLockBodyScroll } from "@brg/ui";
import { useGeneralProps } from '../../../../hooks/useGeneralProps';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin-top: 40px;\n  background: #fefefe;\n  border: 4px solid #f1db63;\n  box-sizing: border-box;\n  box-shadow: none;\n  color: #151514;\n  padding: 40px 48px;\n"], ["\n  position: relative;\n  margin-top: 40px;\n  background: #fefefe;\n  border: 4px solid #f1db63;\n  box-sizing: border-box;\n  box-shadow: none;\n  color: #151514;\n  padding: 40px 48px;\n"])));
var ChooseWrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media (max-width: 940px) {\n    display: none;\n  }\n"], ["\n  @media (max-width: 940px) {\n    display: none;\n  }\n"])));
function Editor(props) {
    var _a = useState(''), editor = _a[0], setEditor = _a[1];
    var _b = useState(null), files = _b[0], setFiles = _b[1];
    var _c = useState(''), dropZone = _c[0], setDropZone = _c[1];
    var lgid = props.lgid, doiserStates = props.doiserStates, colorStyle = props.colorStyle, editLongRead = props.editLongRead, onNewPost = props.onNewPost, specialTools = props.specialTools, thematic = props.thematic, appName = props.appName, hasSpecialSourcesBlocks = props.hasSpecialSourcesBlocks, bookId = props.bookId, firstAsCover = props.firstAsCover, isPresentation = props.isPresentation, onPresentationHeaderChange = props.onPresentationHeaderChange, canAddSpBLock = props.canAddSpBLock, typeConnection = props.typeConnection, editorComponent = props.editorComponent, onLongreadIsReady = props.onLongreadIsReady, commentsAllowed = props.commentsAllowed, allowedActions = props.allowedActions, importantStyle = props.importantStyle, theme = props.theme, isFeed = props.isFeed, blockLength = props.blockLength, isGalleryBp = props.isGalleryBp;
    var setStoryEditor = function () {
        setEditor('story');
    };
    var setChooserEditor = function () {
        setEditor('');
    };
    var setLoadedAction = function (files) {
        setFiles(files);
    };
    var setLoadedDropZone = function (zone) {
        setDropZone(zone);
    };
    useEffect(function () {
        return function () {
            setEditor('');
        };
    }, []);
    var _d = useCommonProps(), fixedRatio = _d.fixedRatio, viewType = _d.viewType, teamContexts = _d.teamContexts, teamExtraFilter = _d.teamExtraFilter, onOpenSetProjectsModal = _d.onOpenSetProjectsModal, sign = _d.sign, isLMS = _d.isLMS, isLMSMain = _d.isLMSMain, projectId = _d.projectId, teamId = _d.teamId, toggleMobileEditor = _d.toggleMobileEditor;
    var generalProps = useGeneralProps();
    var maxProjects = useMemo(function () { return (fixedRatio === WIDE_PRESENTATION_RATIO || ['fluid', 'fixed-ratio-large', 'free-type'].includes(viewType)) ? 3 : 2; }, [fixedRatio, viewType]);
    // if (editor === 'story') {
    return (React.createElement(NewEl, { theme: theme, blockLength: blockLength, hasSpecialSourcesBlocks: hasSpecialSourcesBlocks, canAddSpBLock: canAddSpBLock, lgid: lgid, typeConnection: typeConnection, bookId: bookId, ev: files, dropZone: dropZone, allowedActions: allowedActions, doiserStates: doiserStates, commentsAllowed: commentsAllowed, colorStyle: colorStyle, onNewPost: onNewPost, specialTools: specialTools, num: editLongRead.num, setLoadedAction: setLoadedAction, setLoadedDropZone: setLoadedDropZone, setChooserEditor: setChooserEditor, thematic: thematic, toggleMobileEditor: toggleMobileEditor, appName: appName, firstAsCover: firstAsCover, isPresentation: isPresentation, onPresentationHeaderChange: onPresentationHeaderChange, editorComponent: editorComponent, onLongreadIsReady: onLongreadIsReady, maxProjects: maxProjects, viewType: viewType, teamContexts: teamContexts, teamExtraFilter: teamExtraFilter, onOpenSetProjectsModal: onOpenSetProjectsModal, isLMS: isLMS, isLMSMain: isLMSMain, sign: sign, generalProps: generalProps, teamId: teamId, isFeed: isFeed, projectId: projectId, isGalleryBp: isGalleryBp, importantStyle: importantStyle }));
    // }
    // return (
    //   <ChooseWrap>
    //     <ChooseEl
    //       lgid={lgid}
    //       setEditor={setStoryEditor}
    //       setLoadedAction={setLoadedAction}
    //       setLoadedDropZone={setLoadedDropZone}
    //       colorStyle={colorStyle}
    //     />
    //   </ChooseWrap>
    // )
}
var mapStateToProps = function (store, _a) {
    var currentId = _a.lgid;
    var newEditLongread = getCurrentEditLongread(store, currentId);
    return {
        // countryInnerPageData: store.countryInnerPage.data,
        editLongRead: newEditLongread
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
    // setCreator: (creatorOptions) => dispatch(setCreator(creatorOptions))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Editor);
var templateObject_1, templateObject_2;
//# sourceMappingURL=editor.js.map